module.exports = __webpack_public_path__ + "img/T1A_xh_3.6ffc60de.png";